module.exports = __webpack_public_path__ + "static/media/icon-shown-missing.c8ff9b2e.svg";